
(function() {
    /**
     * Merge the contents of two or more objects together into the first object
     * (based on jQuery extend function)
     * @param {Boolean} [recursive] - recursive flag
     * @param {Object} target - target object
     * @param {Object*} [objectN] - object to merge in
     * @return {Object} target object
     */
    Object.extend = function() {
        var n = 1,
            recursive = false,
            target = arguments[0],
            obj,
            name, src, val;

        // check for recursive flag in first argument
        if (typeof target === 'boolean') {
            recursive = target;
            target = arguments[1];
            n = 2;
        }

        if ((typeof target !== 'object') && (typeof target !== 'function')) {
            target = {};
        }

        for ( ; n < arguments.length; n++) {
            if ((obj = arguments[n]) != null) {
                for (name in obj) {
                    src = target[name];
                    val = obj[name];
                    // convert Number and String object to primitives
                    if (typeof val === 'object') {
                        if (val instanceof Number) {
                            val = Number(val);
                        } else if (val instanceof String) {
                            val = String(val);
                        }
                    }
                    // Try to recursive merge if copy is object and nor array or function
                    if ((recursive) && (typeof val === 'object') && (val) && (!(val instanceof Function)) && (!(val instanceof Array))) {
                        target[name] = Object.extend(recursive, src, val);
                    } else if (val !== undefined) {
                        target[name] = val;
                    }
                }
            }
        }
        return target;
    };
    /**
     * Merging content two or more objects non-recursive to new object
     * @param {Object*} two or more objects
     * @return {Object} the result
     */
    Object.merge = function() {
        var args = [{}];
        for (var i = 0; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return Object.extend.apply(this, args);
    };


    function __p() {}
    /**
     * Create prototype chain for object
     * @param {Object} child - child object
     * @param {Object} parent - parent object
     * @return {Object} child object
     */
    Object.inherit = function(child, parent) {
        __p.prototype = parent.prototype || {};
        child.prototype = new __p();
        child.prototype.constructor = child;
        child.SUPER = parent.prototype;
        return child;
    };

    // Aliases to Function() object

    /**
     * Add prototype chain to object
     * @param {Object} parent - parent object
     * @return {Object}
     */
    Function.prototype.inherit = function(parent) {
        return Object.inherit(this, parent);
    };

    /**
     * Extend object prototype
     * @param {object} proto
     * @return {Function}
     */
    Function.prototype.proto = function(proto) {
        Object.extend(this.prototype, proto);
        return this;
    };
})();

/**
 * Добавим в массив метод indexOf
 */
if (!Array.indexOf) {
    Array.prototype.indexOf = function(searchElement, fromIndex) {
        if (!fromIndex)
            fromIndex = 0;
        for(var i = fromIndex; i < this.length; i ++)
            if (this[i] == searchElement)
                return i;
        return -1;
    };
}

/**
 * Класс для обработки специфических функций браузера
 */
Browser = function() {
    var userAgent = navigator.userAgent.toLowerCase();
    var _ie = /msie/.test(userAgent) && !/opera/.test(userAgent);
    var _old_ie = /MSIE (5\.5|6).+Win/.test(navigator.userAgent);
    var _ie7 = /MSIE (7).+Win/.test(navigator.userAgent);
    var _ie8 = /MSIE (8).+Win/.test(navigator.userAgent);
    var _opera = /opera/.test(userAgent);
    var _webkit = /webkit/.test(userAgent);
    return {
        isOpera: _opera,
        isMSIE: _ie,
        isWebKit: _webkit,
        isIE6: _old_ie,
        isIE7: _ie7,
        isIE8: _ie8,
        /**
         * Определяет область с основной прокруткой
         * (в браузерах на WebKit она волшебным образом отличается
         */
        getScrollBody: function() {
            return (_webkit)
                ? document.body
                : document.documentElement;
        }
    }
}();

/**
 *  Класс для приведения вывода числа, как цены
 */
(function() {
    Number.prototype.toPrice = function() {
        var price = this.toFixed(2);

        var rub = Math.floor(price).toString();
        var kop = Math.floor((price - parseInt(price) + 0.001) * 100);

        var l = rub.length;
        var i = 0;
        var html = '';

        while (i < l) {
            var k = ((i == 0) && (l % 3 > 0))
                ? l % 3
                : 3;
            if (i + k < l) {
                html += '<span>' + rub.substr(i, k) + '</span>';
            } else {
                html += rub.substr(i, k);
            }
            i += k;
        }

        //html += ' <ins>руб</ins>';
        return html;
    };
})();


/**
 * Класс для проверки вводимых данных
 */
InputChecker = function(){
    return {
        /**
         * Проверка на целое число
         * @ параметр: e - event
         * Результат: true, если вводимый символ допустим, false - если нет
         */
        integerInp : function(e) {
            var event = window.event?window.event:e;
            var keyCode = event.keyCode;
            if (!keyCode) { keyCode = event.charCode; }
            if ((keyCode<32)||((keyCode>=48)&&(keyCode<=57))||((!window.event)&&((e.keyCode==37)||(e.keyCode==39)))) {
                return true;
            } else {
                return false;
            }
        },

        /**
         * Проверка на дробное число
         * @ параметр: e - event
         * Результат: true, если вводимый символ допустим, false - если нет
         */
        floatInp: function(e) {
            var event = window.event?window.event:e;
            var keyCode = event.keyCode;
            if (!keyCode) { keyCode = event.charCode; }
            if ((keyCode<32)||((keyCode>=48)&&(keyCode<=57))||(keyCode==44)||(keyCode==46)||((!window.event)&&((e.keyCode==37)||(e.keyCode==39)))) {
                return true;
            } else {
                return false;
            }
        }
    }
}();




